import type { QueryParameterConfig } from '@pba/react-router';
import { type SettingsScope, isSettingsScope } from 'features/settings';

// eslint-disable-next-line @typescript-eslint/naming-convention -- need to be renamed to not eslint error
export const ScopeParameter = {
  decode(value?: Array<null | string> | null | string) {
    if (isSettingsScope(value)) {
      return value;
    }

    return undefined;
  },

  default: undefined,
  encode(value?: SettingsScope) {
    return value;
  },
} satisfies QueryParameterConfig<SettingsScope | undefined>;
